import { render, staticRenderFns } from "./TabOpen.vue?vue&type=template&id=0cb20cd3&scoped=true"
import script from "./TabOpen.vue?vue&type=script&lang=js"
export * from "./TabOpen.vue?vue&type=script&lang=js"
import style0 from "./TabOpen.vue?vue&type=style&index=0&id=0cb20cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb20cd3",
  null
  
)

export default component.exports